export default [
  {
    id: "AR",
    title: "Argentina",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 8003459139

Service Hour: Mon-Fri 9:00-18:00 ART`,
  },

  {
    id: "CL",
    title: "Chile",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 800004227
- **Email**: service.cl@support.mi.com
- **Online Bot and Chat**: [Click Here](https://www.mi.com/cl/)

Service Hour: Mon-Fri 9:00-18:00 CLT`,
  },

  {
    id: "CO",
    title: "Colombia",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 18005190083
- **Email**: service.co@support.mi.com

Service Hour: Mon-Fri 9:00-18:00 COT`,
  },

  {
    id: "EG",
    title: "Egypt",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: ...
- **Email**: service.eg@support.mi.com
- **Online Bot and Chat**: [Click Here](https://www.mi.com/eg/)

Service Hour: Sun-Thu 10:00-19:00 EET`,
  },

  {
    id: "FR",
    title: "France",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 0805 370 916
- **Email**: service.fr@xiaomi.com
- **Online Bot and Chat**: [Click Here](https://sg.chat.kefu.mi.com/page/index/v2?tag=fr&token=c2cjMTAwOCNmci53ZWIubWkjV0FvMExnak9JMCNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=fr&_gl=148npqt_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

Service Hour: Mon-Fri 9:00-20:00 and Sat 9:00-18:00 FST`,
  },

  {
    id: "HK",
    title: "Hong Kong, China",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 852-30773620
- **Email**: service.hk@support.mi.com

Service Hour: 9:00 - 18:00 CST`,
  },

  {
    id: "IN",
    title: "India",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 1800-103-6286
- **Email**: service.in@xiaomi.com
- **Online Bot and Chat**: [Click Here](https://www.mi.com/in/service/online)

Service Hour: 8:00 - 23:00 IST`,
  },

  {
    id: "ID",
    title: "Indonesia",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 180300650029
- **Email**: service.id@support.mi.com
- **Online Bot and Chat**: [Click Here](https://www.mi.co.id/id/index.html)

Service Hour: Mon-Fri 9:00 - 18:00 WIB`,
  },

  {
    id: "IT",
    title: "Italy",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 800 690 921
- **Email**: service.it@xiaomi.com
- **Online Bot and Chat**: [Click Here](https://sg.chat.kefu.mi.com/page/index/v2?tag=it&token=c2cjMTAwNSNpdC5hcHAubWkjSk96eUV5akNSNiNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=it&_gl=148npqt_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

Service Hour: Mon-Fri 9:00-20:00，Sat 9:00-18:00 CEST`,
  },

  {
    id: "JP",
    title: "Japan",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 0120-300-521
- **Email**: service.jp@support.mi.com

Service Hour: Mon-Fri 9:00-18:00 JST`,
  },

  {
    id: "MO",
    title: "Macao, China",
    content: `The customer service team in this country / region provides the following contact methods:
- **Email**: service.mo@support.mi.com

Service Hour: 9:00-18:00 CST`,
  },

  {
    id: "CN",
    title: "Mainland, China",
    content: `The customer service team in this country / region provides the following contact methods:
- **Websites**: https://www.mi.com/service
- **Hotline**: 400-100-5678
- **Online Bot and Chat**: [Click Here](https://support.kefu.mi.com)

Service Hour: 8:00 - 18:00 CST`,
  },

  {
    id: "MY",
    title: "Malaysia",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 1800180112
- **Email**: service.my@support.mi.com
- **Online Bot and Chat**: [Click Here](https://www.mi.com/my/)

Service Hour: Mon-Fri 9:00-18:00 MYT`,
  },

  {
    id: "MX",
    title: "Mexico",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 8002692630
- **Email**: service.mx@support.mi.com
- **Online Bot and Chat**: [Click Here](https://www.mi.com/mx/)

Service Hour: Mon-Fri 9:00-18:00 CDT`,
  },

  {
    id: "PE",
    title: "Peru",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 80009040
- **Email**: service.pe@support.mi.com

Service Hour: Mon-Fri 9:00-18:00 PET`,
  },

  {
    id: "PH",
    title: "Philippines",
    content: `The customer service team in this country / region provides the following contact methods:
- **Email**: service.ph@xiaomi.com`,
  },

  {
    id: "RU",
    title: "Russia",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 8-800-775-66-15
- **Email**: service.ru@xiaomi.com
- **Online Bot and Chat**: [Click Here](https://ru.chat.kefu.mi.com/page/index/v2?tag=ru&token=cnUjMSNydS53ZWIubWkjN3NiMnFNcVk1VCNnb29kc0RldGFpbA%3D%3D&groupId=P0&locale=ru&closedshow=1&_gl=11bs1gaf_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

Service Hour: Mon-Fri 9:00-20:00 EETDST`,
  },

  {
    id: "SG",
    title: "Singapore",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 1800180112
- **Email**: service.sg@support.mi.com
- **Online Bot and Chat**: [Click Here](https://www.mi.com/sg/)

Service Hour: Mon-Fri 9:00-18:00 SGT`,
  },

  {
    id: "ES",
    title: "Spain",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 902 220 250
- **Email**: service.es@xiaomi.com
- **Online Bot and Chat**: [Click Here](https://sg.chat.kefu.mi.com/page/index/v2?tag=cn&token=c2cjMTAwNCNjbi53ZWIubWkuZXMjZGVmYXVsdCNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=es&_gl=11o3sfgo_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

Service Hour: Mon-Fri 9:00-21:00; Sat 9:00-18:00 CEST`,
  },

  {
    id: "TW",
    title: "Taiwan, China",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 02-77255376
- **Email**: service.tw@support.mi.com

Service Hour: 9:00 - 18:00 CST`,
  },

  {
    id: "TH",
    title: "Thailand",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 1800014171
- **Email**: service.th@support.mi.com
- **Online Bot and Chat**: [Click Here](https://www.mi.com/th/)

Service Hour: Mon-Fri 9:00 - 18:00 ICT`,
  },

  {
    id: "UK",
    title: "United Kingdom",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 0800 916 0561
- **Email**: service.uk@xiaomi.com
- **Online Bot and Chat**: [Click Here](https://sg.chat.kefu.mi.com/page/index/v2?tag=uk&token=c2cjMTAwMyN1ay53ZWIubWkjWVdCa21oWmhzViNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=en&_gl=11bs1gaf_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

Service Hour: Mon-Sat 9:00 - 18:00 BST`,
  },

  {
    id: "US",
    title: "United States",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 1-833-XIAOMI8(1-833-942-6648)
- **Email**: service.us@xiaomi.com
- **Online Bot and Chat**: [Click Here](https://sg.chat.kefu.mi.com/page/index/v2?tag=cn&token=c2cjMTAwMyNjbi53ZWIubWkuZW4jZGVmYXVsdCNnb29kc0RldGFpbA==&groupId=P0&closedshow=1&locale=en&_gl=11bs1gaf_gaNTIwNjUzMDA0LjE2MjY0MzM3ODU._ga_M7BZ346GN7*MTYzMTYwNjc2MS42LjAuMTYzMTYwNjc2MS4w)

Service Hour: 8:00 - 18:00 CST`,
  },

  {
    id: "VN",
    title: "Vietnam",
    content: `The customer service team in this country / region provides the following contact methods:
- **Hotline**: 1800400410
- **Email**: service.vn@support.mi.com
- **Online Bot and Chat**: [Click Here](https://www.mi.com/vn/)

Service Hour: Mon-Fri 9:00 - 18:00 ICT`,
  },

  {
    id: "GLOBAL",
    title: "Global - For Other Country / Region",
    content: `The customer service team in this country / region provides the following contact methods:
- **Email**: support.global@support.mi.com`,
  },
];
